import { cn } from '../../lib/cn';

interface ImagePlaceholderProps {
  label: string;
  height?: number | string;
  className?: string;
  rounded?: boolean;
}

/**
 * Stand-in for real photography. Sized/labeled per the design handoff so the
 * property owner can see exactly what asset belongs where before photos exist.
 */
export default function ImagePlaceholder({ label, height = 240, className, rounded = true }: ImagePlaceholderProps) {
  return (
    <div
      className={cn('hs-ph w-full', rounded && 'rounded-md', className)}
      style={{ height: typeof height === 'number' ? `${height}px` : height }}
    >
      {label}
    </div>
  );
}
